import React from 'react';
import { TextHeader, ViewRow } from './layout/PDFLayout';
const BaselinePDFHeader = ({ project }) => {
    return (React.createElement(ViewRow, { style: { justifyContent: 'space-between', alignItems: 'center', paddingBottom: '8px' } },
        React.createElement(TextHeader, { style: { width: '80%' } }, project.name)));
};
export default BaselinePDFHeader;
